import { render, staticRenderFns } from "./ItemsStatement.vue?vue&type=template&id=2cf2180b"
import script from "./ItemsStatement.vue?vue&type=script&lang=js"
export * from "./ItemsStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports